enum ContributionPlanType {
  FIXED_AMOUNT = 'FIXEDAMOUNT',
  PERCENTAGE_OF_G = 'PERCENTAGEOFG',
  PERCENTAGE_OF_SALARY = 'PERCENTAGEOFSALARY',
  UNDEFINED = 'UNDEFINED',
}

export default ContributionPlanType;
